const BASE_URL = 'https://allders-restaurant.web.app'
// const BASE_URL = "http://localhost:3000";

export { BASE_URL };
